// Fixed 8-color accessible sub-palette for position rails. Color is never the
// sole signal — the position name always renders on the pill (WCAG 1.4.1).
export const POSITION_PALETTE = [
  '#004A7B', // interlochen blue
  '#005F40', // forest
  '#58A4B0', // lake
  '#8A4B13', // clay
  '#173F35', // pine
  '#BE3A34', // cherry
  '#B07100', // darkened sunbeam
  '#4A5568', // slate
] as const

export function positionColor(position: { color: string | null; id: string }): string {
  if (position.color) return position.color
  // Stable fallback: hash the id into the palette.
  let h = 0
  for (const c of position.id) h = (h * 31 + c.charCodeAt(0)) >>> 0
  return POSITION_PALETTE[h % POSITION_PALETTE.length]
}
